// extracted by mini-css-extract-plugin
export default {"verifiedImgContainer":"VerifiedText_verifiedImgContainer__mAdTb","verifiedImage":"VerifiedText_verifiedImage__f7y7+","verifiedText":"VerifiedText_verifiedText__+l959"};